import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-handshake-icon',
  templateUrl: './general-handshake.component.html'
})
export class GeneralHandshakeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
